<template>
  <div id="public-app">
    <div class="content">
        <router-view @login="$emit('login')" :key="$route.fullPath"></router-view>
    </div>
  </div>
</template>
<script>
import Login from '@/components/auth/Login'

export default{
  components: { Login }
}
</script>
<style lang="scss">
#public-app{
  background-color: #fff;

  .wrapper{
    max-width: 1200px;
    padding: 0 20px;
  }

  .header{
    background: #fff;
    padding: 20px 0;
    display: none;
  }

  .logo {
    margin: 0;
    .logo--no-text{
      display: none;
    }
    .logo--text{
      display: block;
    }
    @include respond-to("small-up") {
      display: block;
      flex-grow: 0;
    }
  }

  .content{
    padding: 0px 0;
    .wrapper{
      padding:0;
    }
  }

  .login-page{
    .error{
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      background-color: $red-dark;
      color: #ffffff;
      padding: 25px;
    }

    h2 {
      margin: .5em;
      font-size: 1.750em!important;
      line-height: 34px !important
    }

    .subtitle{
      text-align: center;
      font-size: 14px;
      margin-top: 0;
      font-weight: $font-medium;
      color: $ink-lighter;
      margin-bottom: 15px;
    }
  }

  .login-wrapper{
    color: $ink-dark;
  }

  .login-form{
    margin-top: 35px;
  }


  .field{
    max-width: 380px;
    position: relative;
    text-align: left;
    margin-top: 0;

  }

  .optional {
    display: none;
  }
  label {
    color: $ink;
  }
  .field--input{
    max-width: none !important;
    border-radius: 5px;
    background-color: #fff;
    color: $ink-dark;
    border: 1px solid $paper !important;
    padding: 10px 10px;
    font-size: 17px;
    padding-left: 1em;
    border: none;
    box-sizing: border-box;
    height: 48px;
    margin-bottom: 1em;
    text-align: left;
    margin-top: .5em;
    width: 345px;
    line-height: 26px;
    &:hover {
      border: 1px solid $ink-lighter !important;
    }
    &:active {
      border: 1px solid $sensual !important;
    }
    &:focus {
      border: 1px solid $sensual !important;
    }
    @media(max-width: 400px) {
      width: 300px;
    }
  }

  .submit{
    margin-top: 15px;
    text-align: center;
    .btn{
      width: 345px;
      border-radius: 3px;
      font-weight: $font-medium;
      font-size: 1em;
      height: 40px;
      line-height: 16px;
      @media(max-width: 400px) {
        width: 300px;
      }
    }
  }

  .actions{
    text-align: center;
  }

  hr{
    border: none;
    border-top: solid 1px #444444;
    margin: 25px 0;
  }

  a{
    text-decoration: none;
  }

  .footer{
    background: $color-white;
    padding: 1em 0;
    a{
      text-decoration: none;
    }
    .wrapper{
      padding: 0;
      @include respond-to("medium-up") {
        display: flex;
        justify-content: space-between;
        >*{
          align-self: center;
          margin-left: 1em;
          margin-right: 1em;
        }
        &>div{
          width: 33%;
        }
      }
      @include respond-to("medium"){
        text-align: center;
      }
    }
  }
  .footer--second--phone{
    font-size: 2rem;
    margin: 1em 0;
    text-align: center;
    .icon{
      vertical-align: middle;
    }
  }
  .footer--second--address{
    margin: 1em 0;
  }
  .footer--second--logo{
    margin: 1.5em 0;
    text-align: right;
    img{
      display: inline-block;
      margin-left: 0.5em;
    }
  }
  .site-social .menu{
    list-style-type: none;
    display: flex;
    justify-content: center;
    margin: 0;
    padding: 0;
    .menu-item{
      margin: 0 10px;
    }
  }
  .copyright{
    margin-top: 20px;
    color: #b7b7b7;
    text-align: center;
  }
  .btn{
    box-shadow: none;
  }
}
</style>



// WEBPACK FOOTER //
// PublicLayout.vue?4934553e